import { Box, Stack } from "@mui/material";
import version from "../../../../package.json";
import { ProfileCard, SAStoreSelection, SidebarMenu } from ".";
import DashBoardIcon from "../../../assets/images/Icons/Dashboard.svg";
import DeviceIcon from "../../../assets/images/Icons/DeviceIcon.svg";
import Store from "../../../assets/images/Icons/ic_store.svg";
import Tips from "../../../assets/images/Icons/Tips.svg";
import Logo from "../../../assets/images/Logo/Logo.svg";
import { useLocation } from "react-router-dom";
import User from "../../../assets/images/Icons/ic_user.svg";
import MasterdataIcon from "../../../assets/images/Icons/ic_masterdata.svg";
import Label from "../../../assets/images/Icons/ic_label.svg";
import IngredientIcon from "../../../assets/images/Icons/ic_ingredient.svg";
import RecipeIcon from "../../../assets/images/Icons/ic_recipe.svg";
import TemplatesIcon from "../../../assets/images/Icons/ic_templates.svg";
import ProductionChartIcon from "../../../assets/images/Icons/ic_production_chart.svg";
import FutureCostIcon from "../../../assets/images/Icons/view_schedule.svg";
import PosSyncIcon from "../../../assets/images/Icons/ic_posSync.svg";

export const DashboardSidebar = (props) => {
  const { open } = props;

  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const items = [
    {
      href: "/",
      icon: <img alt="icon-Dashboard" alignment="center" src={DashBoardIcon} />,
      title: "Dashboard",
      permission: "dashboard-view",
      storeAdmin: true,
    },
    {
      icon: (
        <img alt="icon-masterdataj" alignment="center" src={MasterdataIcon} />
      ),
      href: "/master-data",
      title: "Master Data",
      permission: [
        "category-view",
        "unit-view",
        "batchgroup-view",
        "wastage-chart-view",
      ],
      storeAdmin: true,
    },
    {
      icon: (
        <img alt="icon-ingredient" alignment="center" src={IngredientIcon} />
      ),
      href: "/ingredients",
      title: "Ingredients",
      permission: ["ingredient-view"],
      storeAdmin: false,
    },
    {
      icon: <img alt="icon-recipe" alignment="center" src={RecipeIcon} />,
      href: "/recipe",
      title: "Recipe",
      permission: ["recipe-view"],
      storeAdmin: false,
    },
    {
      icon: <img alt="icon-template" alignment="center" src={TemplatesIcon} />,
      href: "/templates",
      title: "Templates",
      permission: ["template-view"],
      storeAdmin: true,
    },
    {
      icon: <img alt="icon-pa" alignment="center" src={ProductionChartIcon} />,
      href: "/production-charts",
      title: "Production Charts",
      permission: ["production-chart-view"],
      storeAdmin: true,
    },
    {
      href: "/tips-tricks",
      icon: <img alt="icon-Dashboard" alignment="center" src={Tips} />,
      title: "Tips & Procedures",
      permission: ["Tips&Tricks-view"],
      storeAdmin: false,
    },
    {
      href: "/devices",
      icon: <img alt="icon-Dashboard" alignment="center" src={DeviceIcon} />,
      title: "Devices",
      permission: ["device-view"],
      storeAdmin: false,
    },
    {
      href: "/store",
      icon: <img alt="icon-store" alignment="center" src={Store} />,
      title: "Stores",
      permission: ["store-view"],
      storeAdmin: false,
    },
    {
      href: "/label-printing",
      icon: <img alt="icon-label" alignment="center" src={Label} />,
      title: "Label Printing",
      permission: "label-printing-view",
      storeAdmin: false,
    },
    {
      icon: <img alt="icon-user" alignment="center" src={User} />,
      title: "Users",
      storeAdmin: false,
      subMenu: [
        {
          href: "/manage-users",
          title: "Manage Users",
          permission: ["user-view"],
          storeAdmin: false,
        },
        {
          href: "/roles-and-permissions",
          title: "Roles & Permissions",
          permission: ["role-view"],
          storeAdmin: false,
        },
      ],
    },
    {
      href: "/pos-sync",
      icon: <img alt="icon-pos-sync" alignment="center" src={PosSyncIcon} />,
      title: "POS Sync",
      permission: "future-costing-view",
      storeAdmin: false,
    },
    {
      href: "/future-cost",
      icon: <img alt="future-coast" alignment="center" src={FutureCostIcon} />,
      title: "Future Costing",
      permission: "future-costing-view",
      storeAdmin: false,
    },
    {
      icon: (
        <img alt="icon-stock-take" alignment="center" src={MasterdataIcon} />
      ),
      title: "Stocktake",
      storeAdmin: true,
      subMenu: [
        {
          href: "/stock-categories-tags",
          title: "Stock Categories & Tags",
          permission: "stock-take-view",
          storeAdmin: false,
        },
        {
          href: "/stock-items",
          title: "Stock Items",
          permission: "stock-take-view",
          storeAdmin: true,
        },
        {
          href: "/submissions",
          title: "Submissions",
          permission: "stock-take-view",
          storeAdmin: true,
        },
      ],
    },
  ];

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          py: "16px",
          minHeight: "64px",
        }}
      >
        <img
          alt="logo"
          alignment="center"
          src={Logo}
          style={{
            maxWidth: !open ? "40px" : "",
          }}
        />
      </Box>
      {isStoreAdmin ? (
        <SAStoreSelection collapse={open} />
      ) : (
        <ProfileCard collapse={open} />
      )}
      <Stack sx={{ padding: "0 12px", mb: "8px", gap: "4px" }}>
        {items.map((item, index) => {
          return (
            <SidebarMenu
              item={item}
              index={index}
              key={index}
              collapse={open}
            />
          );
        })}
      </Stack>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginTop: "30px",
          fontSize: "14px",
          textAlign: "center",
          margin: "auto 0 8px",
          color: (theme) =>
            theme.components.MuiDrawer.styleOverrides.paper.color,
        }}
      >
        {isStoreAdmin && <ProfileCard collapse={open} />}
        Version {version.version}
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        width: open ? 240 : 65,
        zIndex: 1200,
        position: "fixed",
        top: "0px",
        left: "0px",
        height: "100%",
        transition: "width .7s ease",
      }}
    >
      <Stack
        anchor="left"
        className="sidebar-drawer"
        sx={{
          backgroundColor: (theme) =>
            theme.components.MuiDrawer.styleOverrides.paper.backgroundColor,
          width: open ? 240 : 65,
          zIndex: 1200,
          position: "fixed",
          top: "0px",
          left: "0px",
          height: "100%",
          overflowY: "auto",
          transition: "width .7s ease",
        }}
      >
        {content}
      </Stack>
    </Box>
  );
};
